import { MenuItem, MenuItemProps, Text } from '@/components/core';
import { DeleteIcon } from '@/components/icons';
import { OmitChildren } from '@/utils';

export type MenuItemDeleteProps = OmitChildren<MenuItemProps>;

export const MenuItemDelete = ({ onAction, ...rest }: MenuItemDeleteProps) => {
  return (
    <MenuItem variant="error" onAction={onAction} {...rest}>
      <DeleteIcon />
      <Text>Delete</Text>
    </MenuItem>
  );
};
